<div class="view-component">
    <div class="view-component-title">
        <span class="title">Fluxo de Integração</span>
    </div>

    <div class="content">
        <div class="tabcontent">
            <mat-tab-group ngClass="custom-tabs" mat-stretch-tabs="false" mat-align-tabs="start">
                <mat-tab> 
                    <ng-template mat-tab-label matTooltip="Fluxo de Pedidos">
                        <mat-icon>shopping_basket</mat-icon>
                    </ng-template>
                    <div class="mktplace">
                        <div class="maindiv-notab">
                            <simple-datagrid entityName='Mktporders' parentRow=""  [condition]="codition" [nodata]="nodata" ></simple-datagrid>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab> 
                    <ng-template mat-tab-label matTooltip="Fluxo de Status">
                        <mat-icon>traffic</mat-icon>
                    </ng-template>
                    <div class="mktplace">
                        <div class="maindiv-notab">
                            <simple-datagrid entityName='Mktpstatus' parentRow=""  [condition]="codition" [nodata]="nodata" ></simple-datagrid>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab> 
                    <ng-template mat-tab-label matTooltip="Fluxo de Produtos">
                        <mat-icon>trip_origin</mat-icon>
                    </ng-template>
                    <div class="mktplace">
                        <div class="maindiv-notab">
                            <simple-datagrid entityName='Mktpskus' parentRow=""  [condition]="codition" [nodata]="nodata" ></simple-datagrid>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</div>
